import * as Base from "@base-ui/react"
import { cva, cx, type VariantProps } from "cva"
import type { PropsWithChildren } from "react"
import { twMerge } from "tailwind-merge"
import { Button } from "./Button.tsx"

export function IconButton(props: IconButton.Props) {
  const { icon, ...rest } = props
  return (
    <Base.Button
      {...rest}
      className={twMerge(
        cx(Button.className(rest), IconButton.className(rest)),
      )}
    >
      <IconButton.Icon icon={icon} size={rest.size} />
    </Base.Button>
  )
}

export namespace IconButton {
  export type Props = PropsWithChildren<
    Base.Button.Props &
      VariantProps<typeof Button.className> &
      VariantProps<typeof className> & {
        icon: React.ElementType
      }
  >

  export const className = cva({
    base: "px-0",
    variants: {
      size: {
        xsmall: "size-[26px]",
        small: "size-[32px]",
        default: "size-[36px]",
        large: "size-[48px]",
      },
    },
    defaultVariants: {
      size: "default",
    },
  })

  export function Icon(props: Icon.Props) {
    const { icon: Icon_, ...rest } = props
    return <Icon_ className={Icon.className(rest)} />
  }

  export namespace Icon {
    export type Props = VariantProps<typeof className> & {
      icon: React.ElementType
    }

    export const className = cva({
      variants: {
        size: {
          xsmall: "size-[14px]",
          small: "size-[16px]",
          default: "size-[18px]",
          large: "size-[24px]",
        },
      },
      defaultVariants: {
        size: "default",
      },
    })
  }
}
